import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Like from './images/like-border.svg';
import LikeFill from './images/like-selected.svg';
import Dislike from './images/dislike-border.svg';
import DislikeFill from './images/dislike-selected.svg';
import Ok from './images/ok.svg';
import Not from './images/not.svg';
import HandsPopUp from './handsPopUp/HandsPopUp';

const HAND_DECISION = {
	UP: 'HAND_UP',
	DOWN: 'HAND_DOWN',
};

const Wrapper = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	margin-right: 12px;
`;

const NewHands = ({ type, forWhat, userVoice, forceNotBlankHands = false }) => {
	const [decision, setDecision] = useState();
	const [showPopUp, setShowPopUp] = useState();

	useEffect(() => {
		if (!showPopUp) return;
		setDecision(showPopUp);
	});

	return (
		<>
			<Wrapper>
				<img
					src={
						decision === HAND_DECISION.UP
							? LikeFill
							: forceNotBlankHands
							? Ok
							: Like
					}
					onClick={() => setShowPopUp(HAND_DECISION.UP)}
					style={{ width: '20px', cursor: 'pointer' }}
				/>
				<img
					src={
						decision === HAND_DECISION.DOWN
							? DislikeFill
							: forceNotBlankHands
							? Not
							: Dislike
					}
					onClick={() => setShowPopUp(HAND_DECISION.DOWN)}
					style={{ width: '20px', cursor: 'pointer' }}
				/>
			</Wrapper>
			{showPopUp && (
				<HandsPopUp
					decision={showPopUp}
					setDecision={setShowPopUp}
					type={type}
					forWhat={forWhat}
					userVoice={userVoice}
				/>
			)}
		</>
	);
};

export default NewHands;
